<template>
  <router-view
      v-bind:registryStatus="appRegistered"
      v-bind:onlineStatus="appOnline"
      v-bind:appVersionNumber="appVersion"
      v-bind:appUpdatingStatus="appUpdating"
      v-bind:appUpdatedStatus="appUpdated"
      v-bind:dbName="dbName"
      v-bind:dbVersion="dbVersion"
  />
</template>

<script>
import {computed, reactive} from 'vue'
import {useHead} from '@unhead/vue'

export default ({
  setup() {
    const siteData = reactive({
      title: `AMH SAFE App`,
      description: `Site to be used by Reps to capture patient data`,
    })
    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `viewport`,
          content: `width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0`,
        }
      ],
      link: [
        {
          rel: `icon`,
          sizes: "192x192",
          href: "img/icons/android-chrome-192x192.png"
        }, {
          rel: `apple-touch-icon`,
          href: "img/icons/apple-touch-icon-152x152.png"
        }, {
          rel: `mask-icon`,
          color: "#000000",
          href: "img/icons/favicon.svg"
        },
      ]
    })
  },
  data() {
    let appVersion;
    if (location.host === 'safeapp.myamh.org') {
      appVersion = 'v4.0.5.20';
    } else {
      appVersion = 'v4.0.5.20';
    }
    return {
      appOnline: false,
      appRegistered: false,
      appUpdating: false,
      appUpdated: false,
      appVersion: appVersion,
      dbName: null,
      dbVersion: null,
    };
  },
  methods: {
    showRegStatus(e) {
      console.log(e.detail);
      let vm = this;
      switch (e.detail) {
        case 'registered':
          vm.appRegistered = true
          break;
      }
    },
    showRefreshUI(e) {
      console.log(e.detail);
      let vm = this;
      switch (e.detail) {
        case 'update downloading':
          vm.appUpdating = true;
          vm.appUpdated = false;
          break;
        case 'updated':
          vm.appUpdating = false;
          vm.appUpdated = true;
          break;
      }
    },
    showConnectionStatus(e) {
      console.log(e.detail);
      let vm = this;
      switch (e.detail) {
        case 'online':
          vm.appOnline = true;
          break;
        case 'offline':
          vm.appOnline = false;
          break;
        default:
          vm.appOnline = true;
          break;
      }

    },
    showAppVersion(e) {
      console.log(e.detail);
      let vm = this;
      vm.appVersion = e.detail;
    },
    useDbDetails(e) {
      let vm = this;
      vm.dbName = e.dbName;
      vm.dbVersion = e.dbVersion;
    },
  },
  mounted() {
    document.addEventListener('regEvent', this.showRegStatus);
    document.addEventListener('updateEvent', this.showRefreshUI);
    document.addEventListener('appVerEvent', this.showAppVersion);
    document.addEventListener('appDbEvent', this.useDbDetails);
    document.addEventListener('connEvent', this.showConnectionStatus);
  },
  beforeUnmount() {
    document.removeEventListener('regEvent', this.showRegStatus);
    document.removeEventListener('updateEvent', this.showRefreshUI);
    document.removeEventListener('appVerEvent', this.showAppVersion);
    document.removeEventListener('appDbEvent', this.useDbDetails);
    document.removeEventListener('connEvent', this.showConnectionStatus);
  },
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
